import axios from "axios";
import { getAuth } from "firebase/auth";

const normalizeAdminBaseUrl = (baseUrl) => {
  const trimmed = (baseUrl || "").replace(/\/+$/, "");
  if (!trimmed) return "/api/v1/admin";
  return trimmed.endsWith("/api/v1/admin") ? trimmed : `${trimmed}/api/v1/admin`;
};

const API_BASE_URL = normalizeAdminBaseUrl(process.env.REACT_APP_API_URL);

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const user = getAuth().currentUser;

    if (user) {
      const token = await user.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    }

    const isFormData =
      typeof FormData !== "undefined" && config.data instanceof FormData;

    if (isFormData && config.headers) {
      if (typeof config.headers.delete === "function") {
        config.headers.delete("Content-Type");
        config.headers.delete("content-type");
      } else {
        delete config.headers["Content-Type"];
        delete config.headers["content-type"];
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
